module.exports = __webpack_public_path__ + "50d359f2d53d04c5c06a805a8e0caa42.svg";